import 'core-js/actual/typed-array/to-base64';
import 'core-js/actual/typed-array/from-base64';
const DEFAULT_ALPHABET = 'base64';
class Base64 {
    data;
    constructor(data) {
        this.data = data;
    }
    static fromBase64 = (base64, alphabet = DEFAULT_ALPHABET) => {
        // @ts-ignore
        const decoded = Uint8Array.fromBase64(base64, { alphabet });
        return new Base64(decoded);
    };
    toBase64 = (alphabet = DEFAULT_ALPHABET) => {
        // @ts-ignore
        return this.data.toBase64(alphabet);
    };
}
export default Base64;
